import React from 'react'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'
import ButtonWithIcon from 'ui/buttons/ButtonWithIcon'
import SVGIcon from 'ui/helpers/SVGIcon'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import AddOrderToPayloadOnPipe from 'support/pipelines/pipes/AddOrderToPayloadOnPipe'
import ClearCartOnPipe from 'support/pipelines/pipes/ClearCartOnPipe'
import PurchaseEventOnPipe from 'services/googleAnalytics/PurchaseEventOnPipe'
import CartBanner from 'services/cart/CartBanner'
import { NavigateOnPipe } from '@morningtrain/react-navigation'

export default function ConfirmCartBanner (props) {
  return (
    <Pipeline>
      <CartBanner>
        <TriggerPipelineOnClick>
          <ButtonWithIcon
            text='Bekræft køb' color='white'
            iconPath={<SVGIcon type='cart' className='-ml-1 mr-2 h-5 w-5' />}
          />
        </TriggerPipelineOnClick>
      </CartBanner>
      <AddOrderToPayloadOnPipe />
      <ExecuteOperationOnPipe resourceName='orders' operationName='purchase' data={p => p.order} />
      <PurchaseEventOnPipe />
      <ClearCartOnPipe />
      <NavigateOnPipe route='app.shop.receipt.receipt' routeParameters={{ order: 'payload:responses.purchase.model.id' }} />
    </Pipeline>
  )
}
